import React from 'react';

import { SvgInfoCircle, SvgClone } from 'components/SvgIcon';

import styles from './DrawerTitleInfo.scss';

const DrawerTitleInfo = () => {
  return (
    <div className={styles.titleInfo}>
      <div className={styles.svgIcon}>
        <SvgInfoCircle />
      </div>
      Need to edit? Click
      <div className={styles.cloneIcon}>
        <SvgClone />
      </div>
      on role to clone.
    </div>
  );
};

export default DrawerTitleInfo;
